import React from 'react';

import * as styles from './BaubleSticker.styles';

export interface BaubleStickerProps {
  content: string;
}

export const BaubleSticker = ({ content }: BaubleStickerProps) => {
  return (
    <div css={styles.container}>
      <img
        src="https://images.contentstack.io/v3/assets/blt83ec2ae5e0dbde7f/bltc99cb429098ab39d/purple_bauble.png"
        alt={content}
      />
    </div>
  );
};
